// Third-party
import React from 'react';
import classNames from 'classnames';
import round from 'lodash/round';

// Components
import { IconButton } from '../../buttons';
import { UnitInput } from '../../inputs';
import { Tooltip } from '../../tooltips';

// Utils
import { FormattedMessage, formatLocalizedString } from '../../../../utils/i18n';
import BMOGIFPortfolioHolding from '@/types/bmo-gif/bmo-gif-portfolio-holding';
import User from '@/types/user';

type Props = {
  portfolioHolding: BMOGIFPortfolioHolding;
  onWeightChange: (id: string, value: number) => void;
  onRemoveHolding: (holding: BMOGIFPortfolioHolding) => void;
  readOnly?: boolean;
  customTemplate?: boolean;
  user?: User | null;
};

class LegacyEditBMOGIFPortfolioHolding extends React.Component<Props> {
  onWeightChange = (holding: BMOGIFPortfolioHolding, weight: number) => {
    const newWeight = Math.max(0, Math.min(100, weight));
    this.props.onWeightChange(holding.id, Math.round(newWeight * 1000000) / 1000000);
  };

  formatAllocation = (value?: number) => `${round(value || 0, 2)}%`;

  render() {
    const { portfolioHolding, readOnly, customTemplate } = this.props;
    const holdingName = formatLocalizedString(portfolioHolding.name);

    return (
      <div className={classNames('bmo-gif-portfolio-holding d-flex align-items-center')}>
        <div className="bmo-gif-portfolio-holding-field column holding flex-grow-1">
          <p className="bmo-gif-portfolio-holding-symbols">
            <span>{portfolioHolding.symbol}</span>
          </p>

          <div className="bmo-gif-portfolio-holding-name d-flex">
            <Tooltip message={holdingName} delayShow={300}>
              <span data-private data-dd-privacy="mask">
                {holdingName}
              </span>
            </Tooltip>
          </div>
        </div>

        <div className="bmo-gif-portfolio-holding-field column weight">
          <span className="field-label weight">
            <FormattedMessage id="HoldingsEditor.Weight" />
          </span>

          <UnitInput
            type="number"
            unitSymbol="%"
            dark
            disabled={readOnly || !customTemplate}
            min={0}
            value={portfolioHolding.weight || ''}
            onValueChange={(value: string) => this.onWeightChange(portfolioHolding, Number(value))}
            onClick={event => event.stopPropagation()}
          />
        </div>

        {!readOnly && customTemplate && (
          <div className="bmo-gif-portfolio-holding-field column delete">
            <IconButton dark icon="ds-delete" onClick={() => this.props.onRemoveHolding(portfolioHolding)} />
          </div>
        )}
      </div>
    );
  }
}

export default LegacyEditBMOGIFPortfolioHolding;
